import * as React from 'react';
import {cn} from '../../lib/cn';

type AirbnbFieldHelperTextProps = {
  id?: string;
  helper?: React.ReactNode;
  disabled?: boolean;
  className?: string;
};

function AirbnbFieldHelperText({
  id,
  helper,
  disabled,
  className,
}: AirbnbFieldHelperTextProps) {
  if (!helper) return null;

  return (
    <p
      id={id}
      className={cn(
        'mt-2 text-[12px] leading-5 text-[var(--chekin-airbnb-gray-text)]',
        disabled && 'opacity-50',
        className,
      )}
    >
      {helper}
    </p>
  );
}

export {AirbnbFieldHelperText};
export type {AirbnbFieldHelperTextProps};
